'use client';

import {useEffect, useState} from "react";
import {useTheme} from "@mui/material/styles";
import {Fab, Fade} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronsUp} from "@fortawesome/pro-duotone-svg-icons";

const ButtonToStart = () => {
    const [isVisible, setIsVisible] = useState(false);
    const theme = useTheme();

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    const handleScroll = () => {
        if (window.scrollY > 200) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <Fade in={isVisible}>
            <Fab
                onClick={scrollToTop}
                sx={{
                    position: "fixed",
                    bottom: 90,
                    right: 20,
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText,
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                    "&:hover": {
                        backgroundColor: theme.palette.primary.dark,
                    },
                }}
                size="large"
            >
                <FontAwesomeIcon icon={faChevronsUp} size="lg"/>
            </Fab>
        </Fade>
    );
};

export default ButtonToStart;
